
export const LeadDesign = [
  {
    order: 1,
    title: 'Lead Information',
    fields: [
      'firstname',
      'middlename',
      'lastname',
      'gender',
      'dob',
      'progress',
      'anniversary',
      'responsible_person',
      'source',
      'enquiry_date',
      'lead_state',
      'email_opt',
      'sms_opt'
    ]
  },
  {
    order: 2,
    title: 'Property Requirements',
    fields: [
      'project',
      'property',
      'min_budget',
      'max_budget',
      'property_type',
      'property_is',
      'property_transaction',
      'area',
      'occupation',
      'how_you_will_purchase',
      'furnishing',
      'miscellaneous'
    ]
  },
  {
    order: 3,
    title: 'Contact Information',
    fields: [
      'phone',
      'email',
      'address'
    ]
  }
];
